import { sspList } from '../../../../common/commonRequests';

export const filters = () => ({
  ssp: {
    name: 'ssp',
    type: 'select',
    label: 'SSP',
    options: () => sspList(false),
    value: '0',
    defaultValue: '0',
    inputWidth: 3
  }
});
